import { useLayoutEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';
import { templatesModel } from '@/entities/templates';

// The catalog holds the templates of one organization. A change of the
// language or of the flag keeps them: a page that reads them fetches them
// again with its own request.
export const useTranscriptorCatalogScope = () => {
  const dispatch = useAppDispatch();
  const organizationId = useAppSelector(
    organizationModel.selectors.selectRelevantOrganizationID,
  );

  useLayoutEffect(() => {
    dispatch(templatesModel.actions.resetCatalog(organizationId));
  }, [organizationId]);
};
